import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const FileThumbnail = styled.figure`
  display: flex;
  width: 47px;
  height: 47px;
  padding: ${Spacing.S4};
  border: 1px solid ${Color.Grey200};
  background-color: ${Color.White};
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
`
